import type { ProcedureInitiative, ProcedureType, Stored } from "@overmap-ai/common"
import { INDEX_FALLBACK } from "@overmap-ai/common"

export const computeProcedureInitiativeIndex = (
	procedureType: Stored<ProcedureType>,
	procedureInitiative: Stored<ProcedureInitiative>,
) => {
	return `${procedureType.name}-${procedureInitiative.index ?? INDEX_FALLBACK}`
}
